/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Current1Inputs */

const zh_accountsettings_current1 = /** @type {(inputs: Accountsettings_Current1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前`)
};

const en_accountsettings_current1 = /** @type {(inputs: Accountsettings_Current1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const es_accountsettings_current1 = /** @type {(inputs: Accountsettings_Current1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Accountsettings_Current1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_current1 = /** @type {((inputs?: Accountsettings_Current1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Current1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_current1(inputs)
	if (locale === "en") return en_accountsettings_current1(inputs)
	return es_accountsettings_current1(inputs)
});
export { accountsettings_current1 as "accountSettings_current" }